import {
  Control,
  ControllerProps,
  FieldValues,
  Path,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { AutocompleteProps } from "@mui/material/Autocomplete";
import { TextFieldProps } from "@mui/material/TextField";

import FormAutocomplete, {
  Option,
} from "../../../../components/reusable-components/form/FormAutocomplete";
import { useColumns } from "../../hooks/useColumns";
import { Column } from "../../models/Column";

interface Props<T extends FieldValues = FieldValues> {
  name: Path<T>;
  control: Control<T>;
  disabled?: boolean;
  controllerProps?: Partial<Omit<ControllerProps<T, Path<T>>, "render">>;
  autocompleteProps?: Partial<AutocompleteProps<Option, false, false, false>>;
  textFieldProps?: TextFieldProps;
}

const ColumnSelectForm = <T extends FieldValues = FieldValues>({
  name,
  control,
  disabled = false,
  controllerProps,
  autocompleteProps,
  textFieldProps,
}: Props<T>) => {
  const { fetch } = useColumns();
  const { data: columns, loading, refetch } = fetch;

  const options: Option[] = (columns ?? []).map((column: Column) => ({
    label: column.name,
    value: column.id,
  }));

  return (
    <FormAutocomplete<T, Path<T>>
      controllerProps={{
        name,
        control,
        ...controllerProps,
      }}
      autocompleteProps={{
        options,
        loading,
        disabled,
        onInputChange: (_, value) =>
          refetch({ params: { search: value, page: 1 } }),
        ...autocompleteProps,
      }}
      textFieldProps={{
        label: "Column",
        placeholder: "Search column...",
        ...textFieldProps,
      }}
    />
  );
};

export default ColumnSelectForm;
